import {
  useController,
  Control,
  FieldValues,
  FieldError,
  Path,
} from 'react-hook-form';

interface TextInputProps<T extends FieldValues> {
  control: Control<T>;
  label?: string;
  name: Path<T>;
  type?: string;
  placeholder?: string;
  icon?: React.ReactNode;
  disabled?: boolean;
}

const TextInput = <T extends FieldValues>({
  control,
  label,
  name,
  type = 'text',
  icon,
  disabled,
  ...rest
}: TextInputProps<T>) => {
  const { field, fieldState } = useController({ control, name });
  const error = fieldState.error as FieldError | undefined;

  return (
    <fieldset className='fieldset p-0'>
      <label className='fieldset-legend'>{label || ''}</label>
      <label className={`w-full input${error ? ' input-error' : ''}`}>
        {icon ?? null}
        <input
          {...rest}
          type={type}
          onChange={field.onChange}
          onBlur={field.onBlur}
          value={field.value || ''}
          disabled={disabled}
        />
      </label>
      <p className='fieldset-label text-red-500 font-semibold'>
        {error ? error.message : ''}
      </p>
    </fieldset>
  );
};

export default TextInput;
